import Item, {ItemAttributesSettable} from '~/shared/src/ci/Item';

import {DATA_UPDATE_ITEM} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {setElusiveData} from '~/frontend/src/actions/elusiveData';
import {MergeMode} from '~/frontend/src/utilities/dataUtils';


/**
 * deleteItem Action
 *
 * @memberOf! Actions
 * @param {string} dataContext
 * @param {number} itemId
 * @param {ItemAttributesSettable} attributes
 * @param {string[]} [additionalElusiveDataContexts=[]]
 *
 * @return {void}
 */
const updateItem = ( dataContext : string, itemId : number, attributes : ItemAttributesSettable, additionalElusiveDataContexts : string[] = [], mergeMode : MergeMode = 'override' ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: DATA_UPDATE_ITEM,
        dataContext,
        itemId,
        attributes,
        additionalElusiveDataContexts
    } );

    const item : Item                                = global.data[ dataContext ]?.items[ itemId ],
          attributesNames                            = Object.keys( attributes ),
          changedAttributes : ItemAttributesSettable = {};

    if ( item && attributesNames.length ) {

        // update item
        for ( const attributeName of attributesNames ) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if ( item[ attributeName ] !== attributes[ attributeName ] ) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                changedAttributes[ attributeName ] = attributes[ attributeName ];
            }
        }

        if ( Object.keys( changedAttributes ).length ) {
            item.clone( changedAttributes, mergeMode !== 'keepExisting' );

            // update ElusiveData
            additionalElusiveDataContexts.unshift( dataContext );
            for ( const elusiveDataContext of additionalElusiveDataContexts ) {
                const elusiveData    = getState().elusiveData?.[ elusiveDataContext ],
                      newElusiveData = {
                          ...elusiveData,
                          data: {
                              ...elusiveData?.data,
                              items     : {
                                  ...elusiveData?.data?.items,
                                  [ item.id ] : ( elusiveData?.data?.items?.[ item.id ] ?? 0 ) + 1
                              },
                              references: elusiveData?.data?.references ?? {}
                          }
                      };

                dispatch( setElusiveData( elusiveDataContext, newElusiveData ) );
            }
        }
    }
}
export type UpdateItem = typeof updateItem;

export default updateItem;
